import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Bg from '../../images/shapes/memecoin_bg_shape_2.svg'
import Bg2 from '../../images/shapes/shape_net_2.svg'

const AnimationAndIllustrationTestimonial = () => {

    const testimonials = [
        {
            id: 1,
            paragraph: "We needed something that could hold attention in under a minute—and they delivered exactly that. The 2D visuals were fun, fluid, and told our story beautifully.",
            title: "Alex J.",
            position: "E-commerce Brand Owner",
        },
        {
            id: 2,
            paragraph: "Their 2D animation team didn’t just animate—they helped us clarify our message. Every frame had a purpose. We've used the video across our campaigns with great results!",
            title: "Rachel S.",
            position: "Marketing Lead",
        },
        {
            id: 3,
            paragraph: "Loved the energy in the animation! It felt custom-made for our audience. The colors, transitions, and voiceover were all spot-on. Highly recommend their 2D team.",
            title: "Martin R.",
            position: "Online Course Creator",
        },
        {
            id: 4,
            paragraph: "I had a rough script and zero visuals. Their illustrators and animators brought everything to life with creativity and care. It looked like something from a major studio.",
            title: "Karan D.",
            position: "Nonprofit Coordinator",
        },
        {
            id: 5,
            paragraph: "Our 3D product demo was absolutely stunning. The details, lighting, and movement made it feel real. Clients actually said ‘wow’—what more can you ask for?",
            title: "Laura V.",
            position: "Tech Startup Founder",
        },
    ];

    var settings = {
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        arrows: true,
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 340,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <section id="id_memecoin_service_section"
            className={`memecoin_service_section z-2 position-relative testimonials`}
            style={{ backgroundImage: `url(${Bg})`, padding:"50px 0" }}
        >
            <div className="container">
                <div className="memecoin_heading_block text-center">
                    <h2 className="heading_text text-uppercase mb-0">
                        WHAT CLIENTS <br /> SAY ABOUT US
                    </h2>
                    <p className="mt-4">The Secret of our long term success in the industry lies in the heart of our customers</p>
                </div>

                <div className="text-left" data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
                    <Slider {...settings}>
                        {testimonials.map((item, index) => (
                            <div className="" key={index}>
                                <p className="px-3">{item.paragraph}</p>
                                <h4 className="px-3">{item.title}</h4>
                                <p className="px-3">{item.position}</p>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default AnimationAndIllustrationTestimonial;
